module.exports = {"home":"홈","totalApl":"전체 APL","serviceOperating":"서비스 운영","serviceIdle":"서비스 대기","aplCommError":"APL 통신 오류","lowBattery":"배터리 부족","batteryOut":"방전","currentGreenTemp":"현재 그린 온도","lastUpdated":"최근 업데이트","refresh":"새로고침","averageTemp":"평균 온도","maxTemp":"최고 온도","minTemp":"최저 온도","tempStatus":"온도상태","temperature":"온도","report":"보고","battery":"배터리","normal":"정상","needCharge":"충전 필요","noData":"데이터가 없습니다."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/ho101.json
// module id = UsiX
// module chunks = 2